<template>
  <div class="login">
    <el-dialog
      width="450px"
      :visible.sync="showW"
      :close-on-click-modal="false"
      @close="close"
    >
      <span slot="title" class="dialog-footer">
        <div class="title">
          <div
            class="item"
            @click="hover = 1"
            :class="hover == 1 ? 'hover' : ''"
          >
            账号登录
          </div>
          <div
            class="item"
            @click="hover = 2"
            :class="hover == 2 ? 'hover' : ''"
          >
            验证码登录
          </div>
        </div>
      </span>
      <el-form
        ref="form"
        :model="ruleForm"
        :rules="rules"
        @submit.native.prevent="submitForm('form')"
      >
        <div class="input" v-if="hover == 1">
          <el-form-item prop="user" style="margin-bottom: 40px">
            <el-input placeholder="请输入账号" v-model="ruleForm.user">
              <template slot="prepend"
                ><i class="el-icon-user-solid"></i
              ></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码"
              type="password"
              v-model="ruleForm.password"
            >
              <template slot="prepend"><i class="el-icon-lock"></i></template>
            </el-input>
          </el-form-item>
        </div>
        <div class="input" v-else>
          <el-form-item prop="phone" style="margin-bottom: 40px" ref="phone">
            <el-input placeholder="请输入手机" v-model="ruleForm.phone">
              <template slot="prepend"
                ><i class="el-icon-user-solid"></i
              ></template>
            </el-input>
          </el-form-item>
          <div class="sendCode">
            <el-form-item prop="code">
              <el-input
                v-model="ruleForm.code"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
            <div class="btn" @click.stop.prevent="sendCode">
              {{ showtime ? count + "秒后重新发送" : "发送验证码" }}
            </div>
          </div>
        </div>

        <div class="checked">
          <div>
            <div v-show="hover === 1">
               <el-checkbox v-model="rememberPassword" />&nbsp;记住密码
            </div>
          </div>
          <div class="right" v-if="hover == 1" @click="toFoget">忘记密码？</div>
          <div class="register" v-if="hover == 2" @click="toRegister">
            立即注册
          </div>
        </div>
        <div class="loginBtn">
          <el-button class="eleBtn" type="primary" @click="submitForm('form')"
            >登录</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { sendSms, login, mobileIsExist } from "@/api/user";
import {getSwitchByUdcCode} from "@/api/order";
import store from "@/vuex/store";
export default {
  name: "login",
  data() {
    var phoneReg = /^1[3-9]\d{9}$/;
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号码"));
      }
      if (!phoneReg.test(value)) {
        callback(new Error("手机号码格式有误"));
      }
      let data = {
        mobile: value,
      };
      mobileIsExist(data).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data) {
            callback();
          } else {
            callback(new Error("手机号码未注册"));
          }
        }
      });
    };
    return {
      checked: false,
      hover: 1,
      count: 60,
      showtime: false,
      timer: null,
      ruleForm: {
        user: "",
        password: "",
        phone: "",
        code: "",
      },
      rules: {
        user: [{ required: true, message: "请输入账号", trigger: "change" }],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "change" }],
      },
      rememberPassword: false,
      domain: document.domain,
      showW: false
    };
  },
  props: {
    showLogin: {
      type: Boolean,
      default: false,
    },
  },
  created() {},

  methods: {
    toFoget() {
      this.$router.push({
        path: "loginAndRegister",
        query: { type: 3 },
      });
      store.commit("CLOSE_LOGIN_BOX");
    },
    toHome() {
      this.$router.push("/");
    },
    toRegister() {
      this.$router.push({
        path: "loginAndRegister",
        query: { type: 1 },
      });
      store.commit("CLOSE_LOGIN_BOX");
    },
    close() {
      store.commit("CLOSE_LOGIN_BOX");
    },
    sendCode() {
      this.$refs.form.validateField("phone", (e) => {
        if (e) {
          return false;
        } else {
          if (!this.timer) {
            this.showtime = true;
            this.timer = setInterval(() => {
              if (this.count > 1 && this.count <= 60) {
                this.count--;
              } else {
                this.showtime = false;
                clearInterval(this.timer);
                this.timer = null;
                this.count = 60;
              }
            }, 1000);

            let data = {
              phone: this.ruleForm.phone,
              smsType: 0,
            };
            sendSms(data).then((res) => {});
          }
        }
      });
    },
    setLogin() {
      let objP = localStorage.getItem(this.domain)
      if(objP) {
        let { hover, user, password } = JSON.parse(objP)
        this.hover = hover
        this.$set(this.ruleForm, "user", user)
        this.$set(this.ruleForm, "password", password)
        this.rememberPassword = true
      }
    },
    rememberP() {
      if(this.rememberPassword){
        localStorage.setItem(
          this.domain,
          JSON.stringify({
            hover: this.hover,
            user: this.ruleForm.user,
            password: this.ruleForm.password,
          })
        );
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            loginType: this.hover == 1 ? 1 : 0,
            username: this.ruleForm.user,
            password: this.ruleForm.password,
            mobile: this.ruleForm.phone,
            smsCode: this.ruleForm.code,
          };
          login(data).then((res) => {
            if (res.data.code == 200) {
              this.rememberP()   //记住密码
              localStorage.setItem(
                "loginUserInfo",
                JSON.stringify(res.data.data)
              );
              localStorage.setItem(
                "personalInfo",
                JSON.stringify(res.data.data)
              );
              store.commit("SET_TOKEN", res.data.data);
              store.commit("CLOSE_LOGIN_BOX");
              getSwitchByUdcCode("CUSTPACK_FLAG")
                .then((res) => {
                  if (res.data.code === 200) {
                    let show=JSON.stringify(res.data.data || false)
                    localStorage.setItem("showPack", show);
                  }
                })
                .catch((err) => {
                  localStorage.setItem("showPack", JSON.stringify(false));
                });
              location.reload();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  watch: {
    showLogin(val){
      this.showW = val;
      if(val) this.setLogin()
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../styles/variables.scss";
.login {
  .title {
    display: flex;
    justify-content: flex-start;
    .item {
      font-size: 18px;
      margin-right: 20px;
      padding-bottom: 10px;
      color: #666;
      cursor: pointer;
    }
    .hover {
      border-bottom: 2px solid $hoverTxtColor;
    }
  }

  .input {
    .sendCode {
      display: flex;
      justify-content: space-between;
      .btn {
        text-align: center;
        width: 150px;
        margin-left: 10px;
        cursor: pointer;
        border: 1px solid #ddd;
        background: #f2f2f2;
        color: #666;
        border-radius: 3px;
        line-height: 40px;
        height: 40px;
      }
    }
  }
  /deep/ .el-input__inner:focus {
    border-color: $mainYellowColor;
  }
  .checked {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .right {
      cursor: pointer;
      color: #666;
    }
    .register {
      cursor: pointer;
      color: #666;
    }
    /deep/ .el-checkbox__inner {
      border-color: $mainYellowColor;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: $mainYellowColor;
    }
  }
  .loginBtn {
    margin-top: 20px;
    /deep/ .el-button--primary {
      width: 100%;
      background-color: $mainYellowColor;
      border-color: $mainYellowColor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue